export default __webpack_public_path__ + "278c1bda308baaa0ec700e56329705bc.png";